"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

// based on: https://github.com/cssinjs/jss/blob/master/packages/jss-plugin-default-unit/src/defaultUnits.js
var defaultUnits = {
  // Animation properties
  animationDelay: "ms",
  animationDuration: "ms",
  // Background properties
  backgroundPosition: "px",
  backgroundPositionX: "px",
  backgroundPositionY: "px",
  backgroundSize: "px",
  // Border Properties
  border: "px",
  borderBottom: "px",
  borderBottomLeftRadius: "px",
  borderBottomRightRadius: "px",
  borderBottomWidth: "px",
  borderLeft: "px",
  borderLeftWidth: "px",
  borderRadius: "px",
  borderRight: "px",
  borderRightWidth: "px",
  borderTop: "px",
  borderTopLeftRadius: "px",
  borderTopRightRadius: "px",
  borderTopWidth: "px",
  borderWidth: "px",
  borderBlock: "px",
  borderBlockEnd: "px",
  borderBlockEndWidth: "px",
  borderBlockStart: "px",
  borderBlockStartWidth: "px",
  borderBlockWidth: "px",
  borderInline: "px",
  borderInlineEnd: "px",
  borderInlineEndWidth: "px",
  borderInlineStart: "px",
  borderInlineStartWidth: "px",
  borderInlineWidth: "px",
  borderStartStartRadius: "px",
  borderStartEndRadius: "px",
  borderEndStartRadius: "px",
  borderEndEndRadius: "px",
  // Margin properties
  margin: "px",
  marginBottom: "px",
  marginLeft: "px",
  marginRight: "px",
  marginTop: "px",
  marginBlock: "px",
  marginBlockEnd: "px",
  marginBlockStart: "px",
  marginInline: "px",
  marginInlineEnd: "px",
  marginInlineStart: "px",
  // Padding properties
  padding: "px",
  paddingBottom: "px",
  paddingLeft: "px",
  paddingRight: "px",
  paddingTop: "px",
  paddingBlock: "px",
  paddingBlockEnd: "px",
  paddingBlockStart: "px",
  paddingInline: "px",
  paddingInlineEnd: "px",
  paddingInlineStart: "px",
  // Mask properties
  maskPositionX: "px",
  maskPositionY: "px",
  maskSize: "px",
  // Width and height properties
  height: "px",
  width: "px",
  minHeight: "px",
  maxHeight: "px",
  minWidth: "px",
  maxWidth: "px",
  // Position properties
  bottom: "px",
  left: "px",
  top: "px",
  right: "px",
  inset: "px",
  insetBlock: "px",
  insetBlockEnd: "px",
  insetBlockStart: "px",
  insetInline: "px",
  insetInlineEnd: "px",
  insetInlineStart: "px",
  // Shadow properties
  boxShadow: "px",
  textShadow: "px",
  // Column properties
  columnGap: "px",
  columnRule: "px",
  columnRuleWidth: "px",
  columnWidth: "px",
  // Font and text properties
  fontSize: "px",
  fontSizeDelta: "px",
  letterSpacing: "px",
  textDecorationThickness: "px",
  textIndent: "px",
  textStroke: "px",
  textStrokeWidth: "px",
  wordSpacing: "px",
  // Motion properties
  motion: "px",
  motionOffset: "px",
  // Outline properties
  outline: "px",
  outlineOffset: "px",
  outlineWidth: "px",
  // Perspective properties
  perspective: "px",
  perspectiveOriginX: "%",
  perspectiveOriginY: "%",
  // Transform properties
  transformOrigin: "%",
  transformOriginX: "%",
  transformOriginY: "%",
  transformOriginZ: "%",
  // Transition properties
  transitionDelay: "ms",
  transitionDuration: "ms",
  // Alignment properties
  verticalAlign: "px",
  flexBasis: "px",
  // Some random properties
  shapeMargin: "px",
  size: "px",
  gap: "px",
  // Grid properties
  grid: "px",
  gridGap: "px",
  rowGap: "px",
  gridRowGap: "px",
  gridColumnGap: "px",
  gridTemplateRows: "px",
  gridTemplateColumns: "px",
  gridAutoRows: "px",
  gridAutoColumns: "px",
  // Custom
  iconSize: "px"
};
var _default = exports.default = defaultUnits;